import type { BoardSnapshot, CardSummary, UpdateCardInput } from '@kaba/shared';
import { api } from '../../lib/api';
import { boardKey, noteLocalEdit, queryClient } from '../../lib/board';
import { toast } from '../../lib/toast';


/**
 * Macht die filterrelevanten Änderungen an einer Karte rückgängig
 * (Titel, Frist, Priorität, Erledigt, Blockiert, Labels, Zuständige).
 */
export async function undoFilterChange(boardId: string, before: CardSummary, after: CardSummary) {
  const current = queryClient.getQueryData<BoardSnapshot>(boardKey(boardId))?.cards.find((c) => c.id === after.id) ?? after;
  const patch: UpdateCardInput = {};
  if (before.title !== current.title) patch.title = before.title;
  if (before.dueAt !== current.dueAt || before.dueHasTime !== current.dueHasTime) {
    patch.dueAt = before.dueAt;
    patch.dueHasTime = before.dueHasTime;
  }
  if (before.startAt !== current.startAt || before.startHasTime !== current.startHasTime) {
    patch.startAt = before.startAt;
    patch.startHasTime = before.startHasTime;
  }
  if (before.priority !== current.priority) patch.priority = before.priority;
  if (!!before.completedAt !== !!current.completedAt) patch.completed = !!before.completedAt;
  if (before.blocked !== current.blocked) {
    patch.blocked = before.blocked;
    if (before.blocked) patch.blockedReason = before.blockedReason ?? null;
  }
  try {
    noteLocalEdit(after.id);
    if (Object.keys(patch).length) await api.patch(`/api/cards/${after.id}`, { ...patch, expectedVersion: current.version });
    // Nur die eigene Änderung umkehren (Delta, L01) – was andere inzwischen gesetzt haben, bleibt
    const inverse = (b: string[], a: string[]) => ({ add: b.filter((x) => !a.includes(x)), remove: a.filter((x) => !b.includes(x)) });
    const lab = inverse(before.labelIds, after.labelIds);
    if (lab.add.length || lab.remove.length) await api.patch(`/api/cards/${after.id}/labels`, lab);
    const ppl = inverse(before.assigneeIds, after.assigneeIds);
    if (ppl.add.length || ppl.remove.length) await api.patch(`/api/cards/${after.id}/assignees`, ppl);
  } catch (err) {
    toast.error(`Rückgängig nicht möglich: ${(err as Error).message}`);
  } finally {
    void queryClient.invalidateQueries({ queryKey: boardKey(boardId) });
  }
}
